import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';

export const SetInitialDocumentDataBadge = ({
  isDone,
  ...props
}: BaseToolBadgeProps) => {
  const allProps = { ...props, isDone };

  return (
    <BaseBadge
      {...allProps}
      showArgs={false}
      resultTexts={{
        loading: 'Initializing document…',
        done: 'Document initialized',
        error: 'Error initializing document',
      }}
    />
  );
};
